import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { MatIcon, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { formatDate } from '@lib/commons/util-functions/format-date.function';

import { TASK_DATA } from '../../../core/contracts/task-data.contract';
import { Task, TaskType } from '../../../core/models/task.interface';
import { TaskDataTargetComponent } from '../../commons/task-data-target/task-data-target.component';

@Component({
  selector: 'app-manual-appointment-cancellation-task-details',
  standalone: true,
  imports: [MatIcon, TaskDataTargetComponent],
  templateUrl: './manual-appointment-cancellation-task-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col gap-6' },
})
export class ManualAppointmentCancellationTaskDetailsComponent {
  private readonly router = inject(Router);

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon('doctor', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_doctor.svg'));
  }

  protected readonly task = inject<Task<TaskType.ManualAppointmentCancellation>>(TASK_DATA);
  protected readonly formatDate = formatDate;

  protected navigateToMemberProfile(): void {
    this.router.navigate(['/members', this.task.data.memberId]);
  }
}
